export default __webpack_public_path__ + "imgs/e15a0420d90d46b6cfa5ca8ae31ed219.png";